import SignIn from '@screens/SignIn';
import { GetStaticProps, NextPage } from 'next';
import withUnauthentication from '@hocs/withUnauthentication';
import { NextSeo } from 'next-seo';
import getConfig from 'next/config';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import { injectLayoutData } from '@utils/layout';

const {
  publicRuntimeConfig: { appBaseUrl },
} = getConfig();

const PageLogin: NextPage = () => {
  const tAccount = useTranslations('Account');
  const router = useRouter();

  return (
    <>
      <NextSeo
        title={tAccount(`loginPageTitle`)}
        canonical={`${appBaseUrl}${router.pathname}`}
        openGraph={{
          url: `${appBaseUrl}${router.pathname}`,
          title: tAccount(`loginPageTitle`),
        }}
      />
      <SignIn />
    </>
  );
};

export const getStaticProps = injectLayoutData<any, GetStaticProps>(
  async () => ({
    props: {},
    revalidate: 1800, // 30min
  }),
);

export default withUnauthentication(
  PageLogin,
  {
    title: `loginPageTitle`,
  },
  true,
);
